var render = function render(){var _vm=this,_c=_vm._self._c;return _c('servislet-overlay',[[_c('div',[_c('header-black'),_vm._t("default")],2)],_c('CartSidebar'),_c('CitySidebar'),_c('TireFinderSidebarRight'),_c('TireMegaSearchWithCar'),_c('TireMegaSearchWithSize'),_c('TireFooter')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }